module.exports = __webpack_public_path__ + "assets/ce8b92944812b19eeff20f752b8acc55.mp3";